import { formatPretty } from "helpers/dateHelper";
import { Card, Table, Button } from "react-bootstrap";
import GenericModalNote from "../Modal/GenericModalNote";
import FamilyService from "../../services/tfamily.service";
import { useState } from "react";
function CollectiveMembers(props) {
  if (
    !props?.collective ||
    !props?.collective?.members ||
    props?.collective?.members?.length === 0
  ) {
    return (
      <Card>
        <Card.Header>
          <Card.Title as="h4">UA Гишүүд</Card.Title>
        </Card.Header>
        <Card.Body>Одоогоор гишүүн байхгүй байна</Card.Body>
      </Card>
    );
  }
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h4" className="mb-0">
          UA Гишүүд
        </Card.Title>
        {/* <Button size="sm" type="button">
                    <i className="fa fa-plus"></i>
                    Гишүүн нэмэх
                </Button> */}
      </Card.Header>
      <Card.Body>
        <Table
          className="table-hover table-striped"
          style={{
            fontSize: "12px",
          }}
        >
          <thead>
            <tr>
              <th className="border-0">UA ID</th>
              <th className="border-0">Утасны дугаар</th>
              {/* <th className="border-0">Овог</th>
              <th className="border-0">Нэр</th>
              <th className="border-0">Регистрийн дугаар</th> */}
              <th className="border-0">Элссэн огноо</th>
              <th className="border-0">Бүртгүүлсэн огноо</th>
              <th className="border-0">Role</th>
              {/* <th className="border-0">Remove</th>
              <th className="border-0">Admin</th> */}
            </tr>
          </thead>
          <tbody>
            {props?.collective?.members?.map((member) => (
              <tr key={member._id}>
                <td>{member._id}</td>
                <td>{member.mobile}</td>
                {/* <td>{member.profile.last_name || ""}</td>
                <td>{member.profile.first_name || ""}</td>
                <td>{member.profile.registration_number || ""}</td> */}
                <td>{formatPretty(member.join_at)}</td>
                <td>{formatPretty(member.created_at)}</td>
                <td>{member.is_admin === 1 ? "админ" : "гишүүн"}</td>
                {/* <td>
                  {member.is_admin !== 1 ? (
                    <GenericModalNote
                      onClick={removeMember}
                      params={{
                        phoneNum: member.mobile,
                        groupId: props.collective.unitel.groupId,
                      }}
                      action={"Хасах"}
                      title={"Групп ээс гишүүн хасах"}
                      body={`Та ${member.mobile} дугаартай гишүүнийг группээс хасахдаа итгэлтэй байна уу?`}
                    />
                  ) : null}
                </td>
                <td>
                  {member.is_admin === 1 ? null : (
                    <GenericModalNote
                      onClick={adminChange}
                      params={{
                        phoneNum: member.mobile,
                        groupId: props.collective.unitel.groupId,
                      }}
                      action={"Админ болгох"}
                      title={"Админ солих"}
                      body={`Та ${member.mobile} дугаартай гишүүнийг админ болгохдоо итгэлтэй байна уу?`}
                    />
                  )}
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
export default CollectiveMembers;
